import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function SiteFooter() {
  return (
    <footer className="bg-[#111827] text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="mb-4" data-testid="footer-brand">
            <img src="https://customer-assets.emergentagent.com/job_lime-booking-hub/artifacts/e4fdgs60_Lime-Driving-School-Original-Version%20%283%29.png"
                 alt="Lime Driving School" className="h-12 w-auto" />
          </div>
          <p className="text-sm text-white/60 leading-relaxed">
            Calm, patient driving lessons across Southampton and surrounding areas. Manual and automatic.
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Sitemap</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-white/80 hover:text-[#37B160]">Home</Link></li>
            <li><Link to="/about" className="text-white/80 hover:text-[#37B160]">About</Link></li>
            <li><Link to="/pricing/manual" className="text-white/80 hover:text-[#37B160]">Manual pricing</Link></li>
            <li><Link to="/pricing/automatic" className="text-white/80 hover:text-[#37B160]">Automatic pricing</Link></li>
            <li><Link to="/packages" className="text-white/80 hover:text-[#37B160]">Packages</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Resources</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/areas-covered" className="text-white/80 hover:text-[#37B160]">Areas covered</Link></li>
            <li><Link to="/reviews" className="text-white/80 hover:text-[#37B160]">Reviews</Link></li>
            <li><Link to="/packages" className="text-white/80 hover:text-[#37B160]">Book now</Link></li>
            <li><Link to="/contact" className="text-white/80 hover:text-[#37B160]">Contact</Link></li>
            <li><Link to="/privacy" className="text-white/80 hover:text-[#37B160]" data-testid="footer-privacy">Privacy policy</Link></li>
            <li><Link to="/terms" className="text-white/80 hover:text-[#37B160]" data-testid="footer-terms">Terms</Link></li>
            <li><Link to="/refund-policy" className="text-white/80 hover:text-[#37B160]" data-testid="footer-refund">Cancellation &amp; refunds</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2 text-white/80"><Phone className="h-4 w-4 text-[#37B160]" /> 07472 887780</li>
            <li className="flex items-center gap-2 text-white/80"><Mail className="h-4 w-4 text-[#37B160]" /> info@limedrivingschool.com</li>
            <li className="flex items-center gap-2 text-white/80"><MapPin className="h-4 w-4 text-[#37B160]" /> Southampton, UK</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Lime Driving School. All rights reserved.</p>
          <p><Link to="/admin" className="hover:text-[#37B160]">Admin</Link></p>
        </div>
      </div>
    </footer>
  );
}
